/* eslint-disable react/jsx-curly-newline */

import React, { useState, useContext } from "react";
import Tabs from "../../components/Tabs";

import Agendamento from "./Agendamento";
import Esteira from "./Esteira";

import { Context } from "../../Context/PermissoesContext";

import "./styles.css";
import Header from "../../components/Header";
import { Container } from "@mui/system";

export default function AgendaPaternidade() {
  const [tab, setTab] = useState(0);
  const { checarPermissaoComAcao } = useContext(Context);

  const handleTabChange = (newValue) => {
    if (newValue === 1) {
      return checarPermissaoComAcao("AGP006", () => setTab(newValue));
    }

    return setTab(newValue);
  };

  return (
    <>
      <Header titulo="Agenda da paternidade" />
      <Container>
        <main className="agenda-paternidade">
          <Tabs
            tabs={["Agendamento", "Esteira"]}
            value={tab}
            handleChange={(e, newValue) => handleTabChange(newValue)}
          />
          {tab === 0 ? <Agendamento /> : null}
        </main>
        {tab === 1 && <Esteira />}
      </Container>
    </>
  );
}
